import React, { useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Loginimage from "../src/images/login.svg";
import Logo from "../src/images/MCRC_logo.svg";
import axios from "axios";
import { LOGIN } from "../src/Utilities/URLCONSTANTS";
import { USER_PROFILE } from "./Utils";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
const Login = () => {
  console.log("Login Component Rendered");
  const { instance } = useMsal();
  const navigate = useNavigate();
  const authAttemptedRef = useRef(false);

  useEffect(() => {
    authAttemptedRef.current = false;
  }, []);
  // Get logged-in Microsoft email
  const getMsalEmail = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0 ? accounts[0].username : "";
  };


  const authenticateMsalToken = async (token) => {
    try {
      const email = getMsalEmail();
      const response = await axios.post(LOGIN, {
        token,
        email,
      });

      sessionStorage.removeItem("authAttempted");

      sessionStorage.setItem(
        "loginResponse",
        JSON.stringify(response.data)
      );

      sessionStorage.setItem("accessToken", token);
      sessionStorage.setItem("email", email);

      if (
        response.data.statusCode !== "101" &&
        response?.data?.response &&
        typeof response.data.response === "object"
      ) {
        sessionStorage.setItem(
          USER_PROFILE,
          JSON.stringify(response.data.response)
        );
      } else {
        sessionStorage.removeItem(USER_PROFILE);
      }

      navigate("/popup");
    } catch (error) {
      sessionStorage.removeItem("authAttempted");

      console.error(error);
    }
  };

  // Sign In button click
  const handleSubmit = async (e) => {
    console.log("Login Render");

    e.preventDefault();

    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  useEffect(() => {
    const accounts = instance.getAllAccounts();
    console.log("Accounts:", accounts);
    const authAttempted =
      sessionStorage.getItem("authAttempted");
    if (accounts.length > 0 && authAttempted !== "true") {
      sessionStorage.setItem("authAttempted", "true");
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          authenticateMsalToken(response.accessToken);
        })
        .catch((error) => {
          console.error("Token Error:", error);

          sessionStorage.removeItem("authAttempted");
        });
    }
  }, [instance]);

  return (
    <div className="bgImage">
      <div className="container">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="row justify-content-center">
            <div className="col-md-10 col-12">
              <div className="card shadow-md login_card">
                <div className="card-body">
                  <div className="row mt-md-3 mt-0">
                    <div className="col-lg-6 m-auto">
                      <div className="w-100 border-r-2-md mb-5">
                        <img
                          src={Loginimage}
                          alt="Login"
                          className="w-100"
                        />
                      </div>
                    </div>
                    <div
                      className="col-lg-6 d-flex flex-column justify-content-center align-items-center"
                      style={{ marginTop: "-30px" }} // Adjust value as needed
                    >
                      <img
                        src={Logo}
                        alt="MCRC Logo"
                        className="logo mb-4"
                      />

                      <form
                        className="w-100 px-md-4 px-4"
                        onSubmit={handleSubmit}
                        style={{ maxWidth: "350px" }}
                      >
                        <button
                          type="submit"
                          className="btn btn-primary w-100 sign_in_button"
                          style={{ height: "45px" }}
                        >
                          Sign In
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;